import React, { useState } from "react";
import painting from "../assets/painting.jpg";
import "./contact.css";

interface IErrors {
  name: string;
  phone: string | number;
  email: string;
  message: string;
}
const Contact = () => {
  const [result, setResult] = React.useState("");
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const accessKey = "YOUR_ACCESS_KEY_HERE";

  const [errors, setErrors] = useState<IErrors>();
  const [submitted, setSubmitted] = useState(false);

  const validate = () => {
    const newErrors: IErrors = {
      name: "",
      phone: "",
      email: "",
      message: "",
    };
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.phone.match(/^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/))
      newErrors.phone = "Phone number is invalid";
    if (!formData.email.match(/^\S+@\S+\.\S+$/))
      newErrors.email = "Email is invalid";
    if (!formData.message) newErrors.message = "Message is required";
    return newErrors;
  };

  const handleChange = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e: any) => {
    e.preventDefault();
    const validationErrors = validate();
    setResult("Sending....");
    setErrors(validationErrors);

    setSubmitted(true);
    const formData = new FormData(e.target);

    formData.append("access_key", "d19e4ad9-344b-49fd-bbf6-72248a183259");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully");
      e.target.reset();
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  return (
    <section>
      <div className="contact-wrapper">
        <img src={painting} alt="Marie-Eve Leclerc" className="hero-image" />
        <div className="contact-overlay">
          <div className="contact-info">
            <h3>
              If you're unsure which service is right for you, or want to see if
              we might be a good fit, I invite you to book a free 15-minute
              phone consultation.
            </h3>
            <br />
            <p>
              Email:{" "}
              <a href="mailto:dr.marie-eve.leclerc@proton.me">
                dr.marie-eve.leclerc@proton.me
              </a>
            </p>
            <p>
              Phone: <a href="tel:(613) 317-3933">(613) 317-3933</a>
            </p>
          </div>
          {!submitted ? (
            <form className="contact-form" onSubmit={onSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
              />
              {errors?.name && <span className="error">{errors.name}</span>}

              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
              />
              {errors?.phone && <span className="error">{errors.phone}</span>}

              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
              />
              {errors?.email && <span className="error">{errors.email}</span>}

              <textarea
                name="message"
                placeholder="Your message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
              {errors?.message && (
                <span className="error">{errors.message}</span>
              )}

              <button type="submit" className="button">
                Submit
              </button>
            </form>
          ) : (
            <p className="success">Thank you for your message!</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default Contact;
